import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './join-index.css'
import { WtfPage } from './WtfPage.tsx'
import './WtfPage.css'
import { captureLanding, initLandingPosthog } from './lib/posthog.ts'
import { setAnalyticsCapture, trackLandingPage } from './tracking.ts'

if (initLandingPosthog('wtf')) {
  setAnalyticsCapture(captureLanding, 'wtf')
}

trackLandingPage()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <WtfPage />
  </StrictMode>,
)
